<template>
  <div class="system">
    <div class="banner" :style="bannerbg">
      <h3>系统演示案例</h3>
      <h6>System Demonstration Case</h6>
    </div>
    <div class="container">
      <el-tabs :tab-position="tabPosition" style="min-height: 200px">
        <el-tab-pane label="产品中心">
          <Syslist :datalist="ptDataList" />
        </el-tab-pane>
        <el-tab-pane label="云智事业部">
          <Syslist :datalist="yzDataList" />
        </el-tab-pane>
        <el-tab-pane label="云优事业部">
          <Syslist :datalist="yyDataList" />
        </el-tab-pane>
        <el-tab-pane label="云帆事业部">
          <Syslist :datalist="yfDataList" />
        </el-tab-pane>

        <!-- <el-tab-pane label="其它演示案例">
          <Otherdemo />
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { doserve } from "@/assets/js/serverUtils.js";
import Syslist from "@/components/system/Syslist.vue";
// import Yunfan from "@/components/system/Yunfan.vue";
// import Yunzhi from "@/components/system/Yunzhi.vue";

export default {
  name: "Home",
  data() {
    return {
      bannerbg: `background:url(${require("../assets/images/getech/banner2.png")}) no-repeat scroll top center/100% 100%;`,
      tabPosition: "left",
      yzDataList: [],
      yyDataList: [],
      yfDataList: [],
      ptDataList: [],
    };
  },
  methods: {},
  async created() {
    let res = await doserve("8999-3");

    let data = JSON.parse(JSON.parse(res.jsobj)["1"] || []).filter((item) => item.show === 1);
    // debugger;
    // debugger;
    this.yzDataList = data.filter((item) => item.division === "yz" && item.show === 1);
    this.yyDataList = data.filter((item) => item.division === "yy" && item.show === 1);
    this.yfDataList = data.filter((item) => item.division === "yf" && item.show === 1);
    this.ptDataList = data.filter((item) => item.division === "pt" && item.show === 1);
    // debugger;
  },

  components: {
    // Basedemo,
    // Chanping,
    Syslist,
    // Yunfan,
    // Yunzhi,
    // Mesdemo,
    // Dccdemo,
    // Srmdemo,
    // Otherdemo,
    // Wmsdemo,
    // HelloWorld
  },
};
</script>
<style lang="scss" scoped></style>
